<template>
  <div class="my_add_btn lineControl" @click="onClick"
       :title="title">
    <span class="el-icon-plus"></span>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_edit_btn',
  data() {
    return {
      baseTitle: i18n.t('components_add_button_index_1953')
    };
  },
  props: {
    coverClick: { // 覆盖默认点击事件
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: i18n.t('components_add_button_index_1953')
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
};
</script>

<style lang="scss" scoped>
.my_add_btn:hover {
  background-color: #2e343B;
}
</style>



// WEBPACK FOOTER //
// src/components/add_button/index.vue